<section>
  <swiper-container
    #swiperContainer
    class="swiper"
    (slidechange)="updateButtonStates()"
  >
    <swiper-slide *ngFor="let m of media">
      <div class="slide-card">
        <!-- картинки -->
        <img
          *ngIf="m.type.startsWith('image')"
          class="image"
          [src]="m.url"
          alt="image"
        />
        <!-- видео -->
        <video *ngIf="m.type.startsWith('video')" class="video" controls>
          <source [src]="m.url" [type]="m.type" />
          Your browser does not support the video tag.
        </video>
      </div>
    </swiper-slide>
  </swiper-container>

  <!-- навигационные кнопки -->
  <div class="btns-container">
    <div class="swiper-btns">
      <button
        class="nav-prev"
        [disabled]="isPrevDisabled"
        (click)="slide('prev')"
      >
        <img src="assets/slide-next.svg" style="rotate: 180deg" />
      </button>

      <button
        class="nav-next"
        [disabled]="isNextDisabled"
        (click)="slide('next')"
      >
        <img src="assets/slide-next.svg" />
      </button>
    </div>
  </div>
</section>
